import { PrmUser } from '../PrmUser.types';

// CONTRACT: id = 0 ist der Sentinel-Wert für Platzhalter-Zeilen (keine echte DB-ID).
// Echte User-Zeilen aus GraphQL haben immer id >= 1 (auto-increment).
// id = 0 stellt sicher, dass getRowId(PrmUserInit) = 0 (valider Grid-Key, kein undefined)
// und commitChanges.js startingAddedId = 0 + 1 = 1 statt undefined + 1 = NaN berechnet.
const PrmUserInit: PrmUser = {
  id: 0,
  first_name: '',
  last_name: '',
  email: '',
  enabled: true,
  last_login: '',
  roles: '',
  username: '',
};
export default PrmUserInit;
